import { useBrand } from '../lib/brand';
import { MarketingShell, usePageMeta } from './chrome';
import { DemoForm } from './DemoForm';

export default function ContactPage() {
  const brand = useBrand();
  usePageMeta(`Contact · ${brand.name}`, `Book a demo of ${brand.name}.`);
  return (
    <MarketingShell>
      <article className="mkt-band mkt-band-tide" data-mkt-surface="dark">
        <div className="mx-auto grid max-w-[1100px] items-start gap-10 px-6 py-mkt-sm md:grid-cols-2 md:py-mkt">
          <div>
            <h1 className="text-balance text-mkt-section-sm text-white md:text-mkt-section">Book a demo.</h1>
            <p className="mt-5 max-w-[28ch] text-[21px] leading-snug text-white md:text-[28px]">
              Tell us about your club. We will write back.
            </p>
          </div>
          <div className="mkt-card p-6 md:p-8">
            <DemoForm />
          </div>
        </div>
      </article>
    </MarketingShell>
  );
}
